import { forwardRef } from "react";

import { Flex, FlexProps } from "@magnetic/flex";

import { withShowToggle } from "src/components/hoc/withShowToggle";

const VFlex = withShowToggle(
  forwardRef<HTMLDivElement, FlexProps>((props: FlexProps, ref) => {
    return (
      <Flex gap={props.gap || "md"} direction="vertical" ref={ref} {...props}>
        {props.children}
      </Flex>
    );
  })
);

export { VFlex };
